export const translations = {
  cy: {
    header: {
      logo: 'AICookingHelp',
      nav: ['Αρχική', 'Δυνατότητες', 'Πώς λειτουργεί', 'Οφέλη', 'Επικοινωνία'],
      cta: 'Ξεκίνα τώρα',
    },
    hero: {
      title: 'Μαγείρεψε έξυπνα με ό,τι έχεις στο σπίτι',
      subtitle:
        'Το AICookingHelp μετατρέπει τα υλικά της κουζίνας σου σε νόστιμες κυπριακές και διεθνείς συνταγές, προσαρμοσμένες στη γεύση και τον χρόνο σου.',
      cta: 'Δες τι μπορώ να μαγειρέψω',
      poweredBy: 'Υποστηρίζεται από τεχνητή νοημοσύνη νέας γενιάς',
      imageAlt: 'Φρέσκα υλικά σε ξύλινο πάγκο κουζίνας',
    },
    features: {
      title: 'Όλα όσα χρειάζεσαι για καθημερινό μαγείρεμα χωρίς άγχος',
      subtitle: 'Από το ψυγείο μέχρι το πιάτο, σε λίγα λεπτά και με καθαρά βήματα.',
      badge: 'Συνταγές σε πραγματικό χρόνο',
      imageAlt: 'Πιάτο με φρέσκια μεσογειακή σαλάτα',
      items: [
        {
          title: 'Αναγνώριση υλικών',
          description:
            'Περίγραψε ή φωτογράφισε ό,τι έχεις στο ψυγείο και η εφαρμογή εντοπίζει γρήγορα χρήσιμους συνδυασμούς.',
        },
        {
          title: 'Προσωπικές προτάσεις',
          description:
            'Παίρνεις ιδέες με βάση τις προτιμήσεις σου, τον χρόνο μαγειρέματος και τις διατροφικές ανάγκες της οικογένειας.',
        },
        {
          title: 'Γρήγορα αποτελέσματα',
          description:
            'Λαμβάνεις καθαρά βήματα και λίστες αγορών μέσα σε δευτερόλεπτα, έτοιμα για το σημερινό γεύμα.',
        },
        {
          title: 'Κυπριακή & παγκόσμια κουζίνα',
          description:
            'Από σουβλάκι και μουσακά μέχρι ασιατικά και ιταλικά πιάτα, πάντα με υλικά που βρίσκεις εύκολα στην Κύπρο.',
        },
      ],
    },
    howItWorks: {
      title: 'Πώς λειτουργεί',
      subtitle: 'Τρία απλά βήματα από τα υλικά σου μέχρι το τραπέζι',
      badge: 'Η βοήθεια σε δράση',
      imageAlt: 'Άτομο που μαγειρεύει με κινητό στην κουζίνα',
      steps: [
        {
          number: '01',
          title: 'Πες τι έχεις',
          description: 'Γράψε υλικά ή ανέβασε μια φωτογραφία από το ψυγείο και τα ντουλάπια σου.',
        },
        {
          number: '02',
          title: 'Άφησε το AI να σκεφτεί',
          description: 'Η τεχνητή νοημοσύνη αξιολογεί γεύσεις, χρόνο και ποσότητες για να σου προτείνει ταιριαστά πιάτα.',
        },
        {
          number: '03',
          title: 'Μαγείρεψε με σιγουριά',
          description: 'Ακολούθησε καθαρά βήματα, εναλλακτικά υλικά και συμβουλές για να βγει το φαγητό σωστά.',
        },
      ],
    },
    benefits: {
      title: 'Γιατί να επιλέξεις AICookingHelp;',
      subtitle: 'Πρακτική βοήθεια για πολυάσχολες μέρες, οικογένειες και όσους θέλουν να μαγειρεύουν καλύτερα στο σπίτι.',
      badge: 'Συνταγές φτιαγμένες για σένα',
      imageAlt: 'Ζεστό σπιτικό φαγητό σε πιάτο',
      items: [
        {
          title: 'Κέρδισε χρόνο',
          description: 'Τέλος στο «τι θα φάμε σήμερα;». Πάρε ιδέες γευμάτων σε δευτερόλεπτα.',
        },
        {
          title: 'Λιγότερη σπατάλη φαγητού',
          description: 'Χρησιμοποίησε ό,τι έχεις ήδη πριν λήξει και μείωσε τα υπόλοιπα στο ψυγείο.',
        },
        {
          title: 'Πιο ισορροπημένα γεύματα',
          description: 'Παίρνεις προτάσεις που σέβονται τις προτιμήσεις σου και μπορούν να προσαρμοστούν σε ελαφρύτερα ή πιο χορταστικά πιάτα.',
        },
        {
          title: 'Ιδανικό για οικογένεια',
          description: 'Ρύθμισε μερίδες, απλές εκδοχές για παιδιά και εναλλακτικές για κοινές αλλεργίες.',
        },
        {
          title: 'Πάντα διαθέσιμο',
          description: 'Η ψηφιακή σου βοήθεια κουζίνας είναι ανοιχτή όλο το εικοσιτετράωρο, στο κινητό σου.',
        },
        {
          title: 'Απλό στη χρήση',
          description: 'Καθαρή διεπαφή, ξεκάθαρα βήματα και χωρίς περίπλοκους όρους μαγειρικής.',
        },
      ],
    },
    cta: {
      title: 'Έτοιμος να μαγειρέψεις χωρίς άγχος;',
      subtitle: 'Ξεκίνα σήμερα και μετέτρεψε τα καθημερινά υλικά σου σε πιάτα που αξίζει να μοιραστείς.',
      cta: 'Ξεκίνα με το AICookingHelp',
      features: ['Χωρίς δεσμεύσεις μακράς διάρκειας', 'Πλήρης πρόσβαση στις δυνατότητες', 'Διαθέσιμο 24/7'],
    },
    footer: {
      company: 'AICookingHelp',
      tagline: 'Έξυπνη βοήθεια κουζίνας για κάθε μέρα',
      quickLinks: 'Γρήγοροι σύνδεσμοι',
      contact: 'Επικοινωνία',
      address: 'Άμστερνταμ, Ολλανδία',
      email: 'cy-support@mobixas.com',
      phone: '80008889',
      rights: 'Όλα τα δικαιώματα διατηρούνται.',
      clickzillas: 'Πάροχος Υπηρεσίας/Διαφημιστικής Προώθησης: Niffo Mobile B.V., Stationsplein 28, 1382 A Weesp, Netherlands (Εμπορικό Επιμελητήριο 96493925).',
      privacy: 'Πολιτική απορρήτου',
      terms: 'Όροι & Προϋποθέσεις',
      cookies: 'Cookies',
      navHome: 'Αρχική',
      navFeatures: 'Δυνατότητες',
      navHow: 'Πώς λειτουργεί',
      navBenefits: 'Οφέλη',
      serviceDescription:
        'Το AICookingHelp είναι μια ψηφιακή υπηρεσία που παρέχει συνταγές και προτάσεις γευμάτων με βάση φωτογραφίες ή πληροφορίες για τα διαθέσιμα υλικά. Η υπηρεσία βοηθά στη μείωση της σπατάλης φαγητού, στην εξοικονόμηση χρημάτων και στην καθημερινή έμπνευση για μαγείρεμα. Τυχόν προτάσεις προϊόντων ή εμπορικών σημάτων δεν συνδέονται ούτε εγκρίνονται από τους αντίστοιχους ιδιοκτήτες.',
      howItWorks: 'Νομικές πληροφορίες υπηρεσίας:',
      howItWorksText:
        'Για τους λεπτομερείς όρους της υπηρεσίας AICookingHelp πηγαίνετε στη σελίδα Όροι & Προϋποθέσεις. Για κάθε αποστολή SMS στον σύντομο κωδικό 6030 υπάρχει χρέωση €12 συμπεριλαμβανομένου ΦΠΑ. Δεν πρόκειται για συνδρομητική υπηρεσία, χρεώνεστε με κάθε SMS που αποστέλλετε εσείς. Εάν θέλετε να διαγραφείτε, απλώς σταματήστε την αποστολή SMS στο 6030.',
      subscription:
        'Τηλεφωνικός αριθμός εξυπηρέτησης πελατών χωρίς χρέωση: 80008889 ή cy-support@mobixas.com. Πάροχος Υπηρεσίας/Διαφημιστικής Προώθησης: Niffo Mobile B.V., Stationsplein 28, 1382 A Weesp, Netherlands, Εμπορικό Επιμελητήριο 96493925, help@niffomobile.com. Πάροχος Σύντομου Κωδικού: EPIC. Η EPIC είναι τηλεπικοινωνιακός / τεχνικός πάροχος και δεν φέρει ουδεμία ευθύνη για την υπηρεσία και την προβολή της. Για οτιδήποτε αφορά την υπηρεσία και την προβολή της, υπεύθυνη είναι αποκλειστικά η διοργανώτρια εταιρεία Niffo Mobile B.V. που την προσφέρει.',
    },
  },
  en: {
    header: {
      logo: 'AICookingHelp',
      nav: ['Home', 'Features', 'How it works', 'Benefits', 'Contact'],
      cta: 'Get started',
    },
    hero: {
      title: 'Cook smarter with what you already have',
      subtitle:
        'AICookingHelp turns the ingredients in your kitchen into tasty Cypriot and international meals, matched to your taste and available time.',
      cta: 'See what I can cook',
      poweredBy: 'Powered by next-generation artificial intelligence',
      imageAlt: 'Fresh ingredients on a wooden kitchen counter',
    },
    features: {
      title: 'Everything you need for calm everyday cooking',
      subtitle: 'From fridge to plate in minutes, with clear steps and practical ideas.',
      badge: 'Recipes in real time',
      imageAlt: 'Fresh Mediterranean salad dish',
      items: [
        {
          title: 'Ingredient awareness',
          description:
            'Describe or photograph what is in your fridge and the app quickly finds useful meal combinations.',
        },
        {
          title: 'Personal suggestions',
          description:
            'Get ideas based on your taste, cooking time and the dietary needs of your household.',
        },
        {
          title: 'Fast results',
          description:
            'Receive clear steps and shopping lists in seconds, ready for tonight’s dinner.',
        },
        {
          title: 'Cypriot and global cuisine',
          description:
            'From souvlaki and moussaka to Asian and Italian plates, always with ingredients easy to find in Cyprus.',
        },
      ],
    },
    howItWorks: {
      title: 'How it works',
      subtitle: 'Three simple steps from your ingredients to the table',
      badge: 'Help in action',
      imageAlt: 'Person cooking with a phone in the kitchen',
      steps: [
        {
          number: '01',
          title: 'Tell us what you have',
          description: 'Type ingredients or upload a photo of your fridge and cupboards.',
        },
        {
          number: '02',
          title: 'Let AI do the thinking',
          description: 'The AI weighs flavours, timing and portions to suggest meals that fit.',
        },
        {
          number: '03',
          title: 'Cook with confidence',
          description: 'Follow clear steps, swap options and tips so the dish turns out right.',
        },
      ],
    },
    benefits: {
      title: 'Why choose AICookingHelp?',
      subtitle: 'Practical support for busy days, families and anyone who wants better home cooking.',
      badge: 'Recipes built for you',
      imageAlt: 'Warm homemade meal on a plate',
      items: [
        {
          title: 'Save time',
          description: 'End the daily “what should we eat?” loop. Get meal ideas in seconds.',
        },
        {
          title: 'Less food waste',
          description: 'Use what you already bought before it spoils and clear leftovers smarter.',
        },
        {
          title: 'More balanced meals',
          description: 'Get suggestions that respect your preferences and can lean lighter or more filling.',
        },
        {
          title: 'Family friendly',
          description: 'Adjust portions, simpler versions for kids and alternatives for common allergies.',
        },
        {
          title: 'Always available',
          description: 'Your digital kitchen helper is open around the clock on your phone.',
        },
        {
          title: 'Simple to use',
          description: 'A clean interface, clear steps and no complicated chef jargon.',
        },
      ],
    },
    cta: {
      title: 'Ready to cook without the stress?',
      subtitle: 'Start today and turn everyday ingredients into meals worth sharing.',
      cta: 'Start with AICookingHelp',
      features: ['No long-term lock-in', 'Full feature access', 'Available 24/7'],
    },
    footer: {
      company: 'AICookingHelp',
      tagline: 'Smart kitchen help for every day',
      quickLinks: 'Quick links',
      contact: 'Contact',
      address: 'Amsterdam, Netherlands',
      email: 'cy-support@mobixas.com',
      phone: '80008889',
      rights: 'All rights reserved.',
      clickzillas: 'Service/Promotion Provider: Niffo Mobile B.V., Stationsplein 28, 1382 A Weesp, Netherlands (Chamber of Commerce 96493925).',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      cookies: 'Cookies',
      navHome: 'Home',
      navFeatures: 'Features',
      navHow: 'How it works',
      navBenefits: 'Benefits',
      serviceDescription:
        'AICookingHelp is a digital service that provides recipes and meal suggestions based on uploaded images or information about available ingredients. The service helps reduce food waste, save money and inspire everyday cooking. Any product or brand recommendations are not affiliated with or endorsed by the respective brand and product owners.',
      howItWorks: 'Service legal information:',
      howItWorksText:
        'For the detailed terms of the AICookingHelp service, go to the Terms & Conditions page. Each SMS sent to short code 6030 is charged €12 including VAT. This is not a subscription service; you are charged for every SMS you send. To stop, simply stop sending SMS messages to 6030.',
      subscription:
        'Free customer service phone number: 80008889 or cy-support@mobixas.com. Service/Promotion Provider: Niffo Mobile B.V., Stationsplein 28, 1382 A Weesp, Netherlands, Chamber of Commerce 96493925, help@niffomobile.com. Short Code Provider: EPIC. EPIC is a telecommunications / technical provider and bears no responsibility for the service or its promotion. For anything related to the service and its promotion, Niffo Mobile B.V. is solely responsible.',
    },
  },
};

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&w=1400&q=80',
  features: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?auto=format&fit=crop&w=1200&q=80',
  howItWorks: 'https://images.unsplash.com/photo-1556911220-bff31c9923b0?auto=format&fit=crop&w=1000&q=80',
  benefits: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=1000&q=80',
};
